/** Current month appears in the picker only within this many days of month-end. */
export const PAYROLL_CURRENT_MONTH_LEAD_DAYS = 3;

function pad2(n) {
  return String(n).padStart(2, "0");
}

export function monthKeyFromDate(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
}

/** Default payroll month: previous calendar month (e.g. May when today is in June). */
export function defaultPayrollMonthKey(today = new Date()) {
  const d = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return monthKeyFromDate(d);
}

/**
 * Whether a month may appear in the payroll month picker.
 * Past months are always allowed; the in-progress month only in the last few days.
 * @param {string} monthKey YYYY-MM
 */
export function isPayrollMonthSelectable(monthKey, today = new Date()) {
  const [y, mo] = String(monthKey).split("-").map(Number);
  if (!y || !mo || mo < 1 || mo > 12) return false;

  const ty = today.getFullYear();
  const tm = today.getMonth() + 1;

  if (y > ty || (y === ty && mo > tm)) return false;
  if (y < ty || mo < tm) return true;

  const lastDay = new Date(y, mo, 0).getDate();
  const earliestDay = lastDay - PAYROLL_CURRENT_MONTH_LEAD_DAYS + 1;
  return today.getDate() >= earliestDay;
}

/**
 * Recent months that are complete (or current month near month-end).
 * @param {number} maxMonths
 */
export function listPayrollSelectableMonthKeys(
  maxMonths = 48,
  today = new Date()
) {
  const keys = [];
  const anchor = new Date(today.getFullYear(), today.getMonth(), 1);
  for (let i = 0; i < maxMonths + 24 && keys.length < maxMonths; i++) {
    const m = new Date(anchor.getFullYear(), anchor.getMonth() - i, 1);
    const key = monthKeyFromDate(m);
    if (isPayrollMonthSelectable(key, today)) keys.push(key);
  }
  return keys;
}

/** If key is not selectable, fall back to default payroll month. */
export function coercePayrollMonthKey(monthKey, today = new Date()) {
  if (monthKey && isPayrollMonthSelectable(monthKey, today)) return monthKey;
  return defaultPayrollMonthKey(today);
}
